import Vue from "vue";
import Vuex from "vuex";

import { forEachModule } from "@/utils/vuex";

// Plugins
import plugins from "./plugins";

// Modules
import accessGroups from "@/store/modules/accessGroups";
import auth from "@/store/modules/auth";
import communities from "@/store/modules/communities";
import config from "@/store/modules/config";
import controller from "@/store/modules/controller";
import descriptions from "@/store/modules/descriptions";
import devices from "@/store/modules/devices";
import install from "@/store/modules/install";
import menu from "@/store/modules/menu";
import roles from "@/store/modules/roles";
import rooms from "@/store/modules/rooms";
import session from "@/store/modules/session";
import userEdit from "@/store/modules/user/edit";
import tickets from "@/store/modules/tickets";
import locks from "@/store/modules/locks";

// TODOD: Move to it's own NPM module
import wizard from "@/api/wizards/store";

Vue.use(Vuex);

const modules = {
	accessGroups,
	auth,
	communities,
	config,
	controller,
	descriptions,
	devices,
	install,
	menu,
	roles,
	rooms,
	session,
	wizard,
	userEdit,
	tickets,
	locks,
};

const actions = {
	initialize({ dispatch }) {
		forEachModule(modules, { dispatch }, "init");
	},
	resetState({ commit }) {
		forEachModule(modules, { commit }, "resetState");
	},
};

export default new Vuex.Store({ plugins, modules, actions });
